<template>
  <section class="content">
    <!-- Default box -->
    <div
      class="card card-solid"
      :style="{ 'min-height': $store.state.screenHeight - 200 + 'px' }"
    >
      <div class="card-body">
        <ul class="nav nav-tabs mb-3">
          <li class="nav-item" @click="tab = 0">
            <a
              class="nav-link"
              :class="{ active: tab == 0 }"
              href="javascript:void(0)"
              >ตั้งค่าการหม่าข้าว</a
            >
          </li>
          <li class="nav-item" @click="tab = 1">
            <a
              class="nav-link"
              :class="{ active: tab == 1 }"
              href="javascript:void(0)"
              >รายงานการหม่าข้าว</a
            >
          </li>
        </ul>

        <div class="card-body pt-0" v-if="tab == 0">
          <div class="row">
            <div class="col-sm-2">ข้าวหม่า 1 กิโลกรัม ได้เป็นข้าวนึ่ง</div>
            <div class="col-sm-2">
              <input
                id="riceKilo"
                type="text"
                class="form-control text-right"
                maxlength="7"
                v-on:keypress="NumbersOnly"
                v-model.number="riceKilos"
              />
            </div>
            <div class="col-sm-2">กิโลกรัม</div>
          </div>
          <br />
          <div class="row">
            <div class="col-sm-2">ข้าวหม่า 1 กระสอบ ได้เป็นข้าวนึ่ง</div>
            <div class="col-sm-2">
              <input
                id="pricebill"
                type="text"
                class="form-control text-right"
                maxlength="5"
                disabled
                :value="numberFormatDecimal(riceKilo * 45)"
              />
            </div>
            <div class="col-sm-2">กิโลกรัม</div>
          </div>
          <br />
          <div class="row">
            <div class="col-sm-2"></div>
            <div class="col-sm-2">
              <button
                type="button"
                class="btn btn-primary btn-block"
                @click="saveSettingRice"
              >
                บันทึก
              </button>
            </div>
            <div class="col-sm-2"></div>
          </div>
        </div>

        <div class="card-body pt-0" v-if="tab == 1">
          <ul class="nav nav-tabs mb-3">
            <li
              class="nav-item"
              @click="
                tabs = 0;
                addDateWeek();
              "
            >
              <a
                class="nav-link"
                :class="{ active: tabs == 0 }"
                href="javascript:void(0)"
                >รายงานข้าวหม่าแบบรายอาทิตย์</a
              >
            </li>
            <li
              class="nav-item"
              @click="
                tabs = 1;
                addNowDate();
              "
            >
              <a
                class="nav-link"
                :class="{ active: tabs == 1 }"
                href="javascript:void(0)"
                >รายงานข้าวหม่าแบบรายวัน</a
              >
            </li>
          </ul>
          <div class="card-body pt-0" v-if="tabs == 0">
            <div class="card-header pb-0" style="border: none;">
              <div class="row">
                <div class="form-group row col-sm-3 pb-0">
                  <label
                    for="date"
                    class="col-sm-4 col-form-label text-right pb-0"
                    >เลือกสาขา</label
                  >
                  <div class="col-sm-8 pb-0">
                    <select
                      class="custom-select mr-sm-2 pb-0"
                      id="Host"
                      v-model="branch"
                    >
                      <option value="0">-- ทุกสาขา --</option>
                      <option
                        v-for="(b, i) in $store.state.branch_list"
                        :key="'branch' + i"
                        :value="b"
                        >{{ b.branch_name }}</option
                      >
                    </select>
                  </div>
                </div>

                <div class="form-group row col-sm-3 pb-0">
                  <label for="date" class="col-sm-4 col-form-label text-right"
                    >จากวันที่</label
                  >
                  <div class="col-sm-8">
                    <a-date-picker
                      v-model="startDate"
                      :format="'DD/MM/YYYY'"
                      style="width: 100%;"
                      :disabledDate="selectDateStart"
                    />
                  </div>
                </div>
                <div class="form-group row col-sm-3 pb-0">
                  <label for="date" class="col-sm-4 col-form-label text-right"
                    >ถึงวันที่</label
                  >
                  <div class="col-sm-8">
                    <a-date-picker
                      v-model="endDate"
                      :format="'DD/MM/YYYY'"
                      style="width: 100%;"
                      :disabledDate="selectDateEnd"
                    />
                  </div>
                </div>
                <div class="form-group row col-sm-2 pb-0">
                  <div class="col-sm-6">
                    <button
                      type="button"
                      class="btn btn-primary btn-block"
                      @click="getReport"
                    >
                      <i class="fas fa-search"></i>&nbsp;ค้นหา
                    </button>
                  </div>
                  <div class="col-sm-6">
                    <form
                      action="/static/excel/report_rice_stk.php"
                      method="POST"
                      target="_blank"
                    >
                      <input
                        type="hidden"
                        name="date_start"
                        v-model="startDate"
                      />
                      <input type="hidden" name="date_end" v-model="endDate" />
                      <input type="hidden" name="data" v-model="form_data" />
                      <button type="submit" class="btn btn-info btn-block">
                        <i class="far fa-file-excel"></i> Excel
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center pt-3" v-if="report_data.length < 1">
              <h5>ไม่มีข้อมูล</h5>
            </div>
            <div class="table-responsive-sm mt-3" v-if="report_data.length > 0">
              <div
                class="table-responsive-sm mt-3"
                v-for="(c, i) in report_data"
                :key="'c' + i"
                v-if="c.sub.length > 0"
              >
                <h4 class="m-1 p-1">
                  {{ c.branchName }}
                  <span style="font-size: 14px;"
                    >({{ dateFormatDMY(startDate) }} -
                    {{ dateFormatDMY(endDate) }})</span
                  >
                </h4>
                <div v-for="(d, p) in c.sub" :key="'d' + p">
                  <table class="table mb-0">
                    <tbody>
                      <tr class="thead-dark text-center trTop">
                        <th class="text-left trTop" width="10%">#</th>
                        <th class="text-left trTop">วันเวลา (หม่าข้าว)</th>
                        <th class="text-right trTop" width="10%">
                          จำนวนกระสอบ
                        </th>
                        <th class="text-right trTop" width="10%">
                          จำนวนกิโล
                        </th>
                        <th class="text-right trTop">
                          ได้ข้าวนึ่งจำนวน (กิโลกรัม)
                        </th>
                        <th class="text-center trTop">
                          แก้ไข
                        </th>
                      </tr>
                      <tr v-for="(s, x) in d.subDate" :key="'s' + x">
                        <td class="text-left">{{ x + 1 }}</td>
                        <td class="text-left">
                          {{ changeFormatDate(s.riceDate) }}
                        </td>
                        <td class="text-right">
                          {{
                            numberFormatDecimal(parseFloat(s.kasob).toFixed(0))
                          }}
                        </td>
                        <td class="text-right">
                          {{
                            numberFormatDecimal(parseFloat(s.kilo).toFixed(0))
                          }}
                        </td>
                        <td class="text-right">
                          {{ numberFormatDecimal(s.summeryRice) }}
                        </td>
                        <th class="text-center">
                          <button
                            type="button"
                            class="btn btn-warning btn-sm"
                            style="padding: 0 0.25rem; margin: 0.25rem;"
                            @click="
                              modal_active = true;
                              modal_title = `แก้ไขข้อมูลหม่าข้าว`;
                              editRice(d, s);
                            "
                          >
                            <i class="fas fa-edit"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-danger btn-sm"
                            style="padding: 0 0.25rem; margin: 0.25rem;"
                            @click="deleteRice(d, s)"
                          >
                            <i class="fas fa-trash"></i>
                          </button>
                        </th>
                      </tr>
                    </tbody>
                  </table>
                  <!-- <table class="table mb-0">
                      <tbody>
                        <tr class="thead-dark text-center">
                          <th class="text-left trMid" style="width:20%">
                            วันที่ : {{ d.riceDate }}
                          </th>
                          <th class="text-left trMid">
                            หม่าข้าวทั้งสิ้น :
                            {{ numberFormatDecimal(d.sumKasob) }} กระสอบ |
                            {{ numberFormatDecimal(d.sumKilo) }} กิโลกรัม
                            (คิดเป็นข้าวหม่าทั้งหมด
                            {{
                              numberFormatDecimal(
                                parseFloat(d.sumKasob * 45) +
                                  parseFloat(d.sumKilo)
                              )
                            }}
                            กิโลกรัม)
                          </th>
                          <td class="text-left trMid"></td>
                          <th class="text-left trMid"></th>
                          <th class="text-right trMid">ได้ข้าวนึ่งทั้งสิ้น</th>
                          <th class="text-right trMid">
                            {{ numberFormatDecimal(d.sumRice) }}
                          </th>
                          <th class="text-left trMid" style="width:5%">
                            กิโลกรัม
                          </th>
                        </tr>
                      </tbody>
                    </table> -->
                  <table class="table mb-0">
                    <tbody>
                      <tr class="thead-dark text-center formpc">
                        <th class="text-left trBot">
                          วันที่หม่าข้าว : {{ d.riceDate }}
                        </th>
                        <th class="text-left trBot">
                          ได้ข้าวหม่าทั้งสิ้น :
                          {{
                            numberFormatDecimal(
                              parseFloat(d.sumKasob * (riceKilo * 45)) +
                                parseFloat(d.sumKilo * riceKilo)
                            )
                          }}
                          กิโลกรัม
                        </th>
                        <th class="text-left trBot">
                          ขายข้าวนึ่ง :
                          {{ numberFormatDecimal(d.sumWeight) }} กิโลกรัม
                        </th>
                        <td class="text-left trBot">
                          &nbsp;
                        </td>
                        <th class="text-right trBot">
                          เหลือ
                          {{
                            numberFormatDecimal(
                              parseFloat(d.sumKasob * (riceKilo * 45)) +
                                parseFloat(d.sumKilo * riceKilo) -
                                d.sumWeight
                            )
                          }}
                          กิโลกรัม
                        </th>
                        <!-- <th class="text-right trBot">
                          คงเหลือ
                          {{ numberFormatDecimal(d.sumAmount) }} กิโลกรัม
                        </th> -->
                        <!-- <th class="text-right trBot">
                            สูญเสีย
                            <span class="tdtextColor">{{
                              numberFormatDecimal(d.sumLost)
                            }}</span>
                            กิโลกรัม คิดเป็นเปอร์เซ็น
                          </th>
                          <th class="text-right trBot">
                            <span class="tdtextColor">{{
                              numberFormatDecimal(d.sumLostPercent)
                            }}</span>
                          </th>
                          <th class="text-left trBot" style="width:5%">%</th> -->
                      </tr>
                      <tr class="thead-dark text-center formmobile">
                        <th class="text-left trBot">
                          วันที่ : {{ d.riceDate }}
                        </th>
                        <th class="text-left trBot">
                          ได้ข้าวหม่า :
                          {{
                            numberFormatDecimal(
                              parseFloat(d.sumKasob * (riceKilo * 45)) +
                                parseFloat(d.sumKilo * riceKilo)
                            )
                          }}
                          กก
                        </th>
                        <th class="text-left trBot">
                          ขายข้าวนึ่ง :
                          {{ numberFormatDecimal(d.sumWeight) }} กก
                        </th>
                        <td class="text-left trBot">
                          &nbsp;
                        </td>
                        <th class="text-right trBot">
                          เหลือ
                          {{
                            numberFormatDecimal(
                              parseFloat(d.sumKasob * (riceKilo * 45)) +
                                parseFloat(d.sumKilo * riceKilo) -
                                d.sumWeight
                            )
                          }}
                          กก
                        </th>
                        <!-- <th class="text-right trBot">
                          คงเหลือ
                          {{ numberFormatDecimal(d.sumAmount) }} กิโลกรัม
                        </th> -->
                        <!-- <th class="text-right trBot">
                            สูญเสีย
                            <span class="tdtextColor">{{
                              numberFormatDecimal(d.sumLost)
                            }}</span>
                            กิโลกรัม คิดเป็นเปอร์เซ็น
                          </th>
                          <th class="text-right trBot">
                            <span class="tdtextColor">{{
                              numberFormatDecimal(d.sumLostPercent)
                            }}</span>
                          </th>
                          <th class="text-left trBot" style="width:5%">%</th> -->
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body pt-0" v-if="tabs == 1">
            <div class="card-header pb-0" style="border: none;">
              <div class="row">
                <div class="form-group row col-sm-3 pb-0">
                  <label
                    for="date"
                    class="col-sm-4 col-form-label text-right pb-0"
                    >เลือกสาขา</label
                  >
                  <div class="col-sm-8 pb-0">
                    <select
                      class="custom-select mr-sm-2 pb-0"
                      id="Host"
                      v-model="branch"
                    >
                      <option value="0">-- ทุกสาขา --</option>
                      <option
                        v-for="(b, i) in $store.state.branch_list"
                        :key="'branch' + i"
                        :value="b"
                        >{{ b.branch_name }}</option
                      >
                    </select>
                  </div>
                </div>

                <div class="form-group row col-sm-3 pb-0">
                  <label for="date" class="col-sm-4 col-form-label text-right"
                    >จากวันที่</label
                  >
                  <div class="col-sm-8">
                    <a-date-picker
                      v-model="startDate"
                      :format="'DD/MM/YYYY'"
                      style="width: 100%;"
                      :disabledDate="selectDateStart"
                    />
                  </div>
                </div>
                <div class="form-group row col-sm-3 pb-0">
                  <label for="date" class="col-sm-4 col-form-label text-right"
                    >ถึงวันที่</label
                  >
                  <div class="col-sm-8">
                    <a-date-picker
                      v-model="endDate"
                      :format="'DD/MM/YYYY'"
                      style="width: 100%;"
                      :disabledDate="selectDateEnd"
                    />
                  </div>
                </div>
                <div class="form-group row col-sm-2 pb-0">
                  <div class="col-sm-6">
                    <button
                      type="button"
                      class="btn btn-primary btn-block"
                      @click="getReport"
                    >
                      <i class="fas fa-search"></i>&nbsp;ค้นหา
                    </button>
                  </div>
                  <div class="col-sm-6">
                    <form
                    action="/static/excel/report_rice_stk.php"
                    method="POST"
                    target="_blank"
                  >
                    <input
                      type="hidden"
                      name="date_start"
                      v-model="startDate"
                    />
                    <input type="hidden" name="date_end" v-model="endDate" />
                    <input type="hidden" name="data" v-model="form_data" />
                    <button type="submit" class="btn btn-info btn-block">
                      <i class="far fa-file-excel"></i> Excel
                    </button>
                  </form>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center pt-3" v-if="report_data.length < 1">
              <h5>ไม่มีข้อมูล</h5>
            </div>
            <div class="table-responsive-sm mt-3" v-if="report_data.length > 0">
              <div
                class="table-responsive-sm mt-3"
                v-for="(c, i) in report_data"
                :key="'c' + i"
                v-if="c.sub.length > 0"
              >
                <h4 class="m-1 p-1">
                  {{ c.branchName }}
                  <span style="font-size: 14px;"
                    >({{ dateFormatDMY(startDate) }} -
                    {{ dateFormatDMY(endDate) }})</span
                  >
                </h4>
                <div v-for="(d, p) in c.sub" :key="'d' + p">
                  <table class="table mb-0">
                    <tbody>
                      <tr class="thead-dark text-center trTop">
                        <th class="text-left trTop" width="10%">#</th>
                        <th class="text-left trTop">วันเวลา (หม่าข้าว)</th>
                        <th class="text-right trTop" width="10%">
                          จำนวนกระสอบ
                        </th>
                        <th class="text-right trTop" width="10%">
                          จำนวนกิโล
                        </th>
                        <th class="text-right trTop">
                          ได้ข้าวนึ่งจำนวน (กิโลกรัม)
                        </th>
                        <th class="text-center trTop">
                          แก้ไข
                        </th>
                      </tr>
                      <tr v-for="(s, x) in d.subDate" :key="'s' + x">
                        <td class="text-left">{{ x + 1 }}</td>
                        <td class="text-left">
                          {{ changeFormatDate(s.riceDate) }}
                        </td>
                        <td class="text-right">
                          {{
                            numberFormatDecimal(parseFloat(s.kasob).toFixed(0))
                          }}
                        </td>
                        <td class="text-right">
                          {{
                            numberFormatDecimal(parseFloat(s.kilo).toFixed(0))
                          }}
                        </td>
                        <td class="text-right">
                          {{ numberFormatDecimal(s.summeryRice) }}
                        </td>
                        <th class="text-center">
                          <button
                            type="button"
                            class="btn btn-warning btn-sm"
                            style="padding: 0 0.25rem; margin: 0.25rem;"
                            @click="
                              modal_active = true;
                              modal_title = `แก้ไขข้อมูลหม่าข้าว`;
                              editRice(d, s);
                            "
                          >
                            <i class="fas fa-edit"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-danger btn-sm"
                            style="padding: 0 0.25rem; margin: 0.25rem;"
                            @click="deleteRice(d, s)"
                          >
                            <i class="fas fa-trash"></i>
                          </button>
                        </th>
                      </tr>
                    </tbody>
                  </table>
                  <table class="table mb-0">
                    <tbody>
                      <tr class="thead-dark text-center">
                        <th class="text-left trMid" style="width:20%">
                          วันที่ : {{ d.riceDate }}
                        </th>
                        <th class="text-left trMid">
                          หม่าข้าวทั้งสิ้น :
                          {{ numberFormatDecimal(d.sumKasob) }} กระสอบ |
                          {{ numberFormatDecimal(d.sumKilo) }} กิโลกรัม
                          (คิดเป็นข้าวหม่าทั้งหมด
                          {{
                            numberFormatDecimal(
                              parseFloat(d.sumKasob * 45) +
                                parseFloat(d.sumKilo)
                            )
                          }}
                          กิโลกรัม)
                        </th>
                        <td class="text-left trMid"></td>
                        <th class="text-left trMid"></th>
                        <th class="text-right trMid">ได้ข้าวนึ่งทั้งสิ้น</th>
                        <th class="text-right trMid">
                          {{ numberFormatDecimal(d.sumRice) }}
                        </th>
                        <th class="text-left trMid" style="width:5%">
                          กิโลกรัม
                        </th>
                      </tr>
                    </tbody>
                  </table>
                  <table class="table mb-0">
                    <tbody>
                      <tr class="thead-dark text-center">
                        <th class="text-left trBot" style="width:20%">
                          สรุปการขายประจำวันที่ : {{ d.riceDate }}
                        </th>
                        <th class="text-left trBot">
                          ขายข้าวนึ่งไปทั้งสิ้น :
                          {{ numberFormatDecimal(d.sumWeight) }} กิโลกรัม
                        </th>
                        <td class="text-left trBot" style="width:7.5%">
                          &nbsp;
                        </td>
                        <th class="text-right trBot">
                          เหลือ {{ numberFormatDecimal(d.sumStock) }} กิโลกรัม
                        </th>
                        <th class="text-right trBot">
                          คงเหลือที่นับได้
                          {{ numberFormatDecimal(d.sumAmount) }} กิโลกรัม
                        </th>
                        <th class="text-right trBot">
                          สูญเสีย
                          <span class="tdtextColor">{{
                            numberFormatDecimal(d.sumLost)
                          }}</span>
                          กิโลกรัม คิดเป็นเปอร์เซ็น
                        </th>
                        <th class="text-right trBot">
                          <span class="tdtextColor">{{
                            numberFormatDecimal(d.sumLostPercent)
                          }}</span>
                        </th>
                        <th class="text-left trBot" style="width:5%">%</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a-modal
      :title="modal_title"
      centered
      v-model="modal_active"
      @ok="save_modal()"
      @cancel="close_modal"
    >
      <div class="form-group row mb-1">
        <label for="vendor_name" class="col-sm-3 text-right col-form-label"
          >วันเวลา (หม่าข้าว)</label
        >
        <div class="col-sm-8">
          <a-date-picker
            v-model="editDate"
            :format="'DD/MM/YYYY'"
            style="width: 100%;"
          />
        </div>
      </div>
      <div class="form-group row mb-1">
        <label for="vendor_name" class="col-sm-3 text-right col-form-label"
          >จำนวนกระสอบ
        </label>
        <div class="col-sm-8">
          <input
            type="text"
            class="form-control"
            id="vendor_name"
            maxlength="6"
            v-on:keypress="NumbersOnly"
            placeholder="จำนวนกระสอบ...."
            v-model.number="adjustKasobs"
          />
        </div>
      </div>
      <div class="form-group row mb-1">
        <label for="vendor_name" class="col-sm-3 text-right col-form-label"
          >จำนวนกิโล</label
        >
        <div class="col-sm-8">
          <input
            type="text"
            class="form-control"
            id="vendor_name"
            maxlength="6"
            v-on:keypress="NumbersOnly"
            placeholder="จำนวนกิโล...."
            v-model.number="adjustKilos"
          />
        </div>
      </div>
    </a-modal>
  </section>
</template>

<script>
/* eslint-disable */
import moment from "moment";
import apiMain from "../services/service";
import api from "../services/service_report";
import apipos from "../services/service_pos";
import apiCenter from "../services/service_undefined";
import apiCenterV2 from "../services/service_undefined_v2";
import apiCus from "@/services/service_customer";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      riceKilo: 0.0,
      riceKasob: 45,
      adjustKilo: 0.0,
      adjustKasob: 0.0,
      idChange: "",
      tab: 0,
      tabs: 0,
      report_data: [],
      startDate: moment().add(-7, "days"),
      data_edit: {},
      data_edit_pay: {},
      endDate: moment().add(7, "days"),
      header: {
        headers: {
          "Access-Token": sessionStorage.token
        }
      },
      form_data: "",
      branch: 0,
      branchId: "",
      branchName: "",
      changeBranchName: "",
      host_list: [],
      host: null,
      data_cus_list: [],
      begin_code: "",
      end_code: "",
      dyn_address: "",
      modal_title: "",
      modal_active: false,
      editDate: moment(new Date())
    };
  },
  computed: {
    riceKilos: {
      get: function() {
        if (this.riceKilo !== "") return parseFloat(this.riceKilo).toFixed(2);
        else return parseFloat(0).toFixed(2);
      },
      set: function(newValue) {
        this.riceKilo = newValue;
      }
    },
    riceKasobs: {
      get: function() {
        if (this.riceKasob !== "") return parseFloat(this.riceKasob).toFixed(2);
        else return parseFloat(0).toFixed(2);
      },
      set: function(newValue) {
        this.riceKasob = newValue;
      }
    },
    adjustKilos: {
      get: function() {
        if (this.adjustKilo !== "")
          return parseFloat(this.adjustKilo).toFixed(2);
        else return parseFloat(0).toFixed(2);
      },
      set: function(newValue) {
        this.adjustKilo = newValue;
      }
    },
    adjustKasobs: {
      get: function() {
        if (this.adjustKasob !== "")
          return parseFloat(this.adjustKasob).toFixed(2);
        else return parseFloat(0).toFixed(2);
      },
      set: function(newValue) {
        this.adjustKasob = newValue;
      }
    }
  },
  methods: {
    // getMonday(d) {
    //   d = new Date(d);
    //   var day = d.getDay(),
    //       diff = d.getDate() - day + (day == 0 ? -6:1); // adjust when day is sunday
    //   return new Date(d.setDate(diff));
    // },
    addDateWeek() {
      //console.log(this.getMonday(new Date()));

      var curr = new Date(); // get current date
      var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
      var last = first + 6; // last day is the first day + 6

      var firstday = new Date(curr.setDate(first)).toUTCString();
      var lastday = new Date(curr.setDate(last)).toUTCString();

      this.startDate = moment(firstday);
      this.endDate = moment(lastday);
    },
    addNowDate() {
      this.startDate = moment(new Date());
      this.endDate = moment(new Date());
    },
    save_modal() {
      // this.$store.commit("Loading");
      const dataUser = JSON.parse(sessionStorage.user);
      apiCenterV2.changeRemainStock(
        {
          id: this.idChange,
          editDate: this.editDate,
          branchName: this.changeBranchName,
          kilo: this.adjustKilo,
          kasob: this.adjustKasob,
          summeryRice:
            this.adjustKilo * this.riceKilo +
            this.adjustKasob * (this.riceKilo * 45),
          createdBy: dataUser.role_name
        },
        this.header,
        results => {
          // this.$store.commit("Loading");
          this.$notification["success"]({
            message: "บันทึกข้อมูลสำเร็จ",
            description: ""
          });
          this.getReport();
          // if (results.data.isStatus) {
          //   this.report_data = results.data.data;
          // }
        },
        errors => {
          // this.$store.commit("Loading");
          this.$notification["warning"]({
            message: "ไม่สามารถทำการเปลี่ยนแปลงข้อมูลได้",
            description: errors.data.message
          });
        }
      );
      this.modal_active = false;
    },
    close_modal() {
      this.modal_active = false;
    },
    changeFormatDate(dateValue) {
      // return dateValue
      //   .replace("T", " ")
      //   .replace(".000Z", "")
      //   .replaceAll("-", "/");
      return moment(dateValue).format("DD/MM/yyyy hh:mm:ss");
    },
    editRice(e, s) {
      this.changeBranchName = s.branchName;
      this.adjustKasobs = s.kasob;
      this.adjustKilos = s.kilo;
      this.editDate = moment(s.riceDate);
      this.idChange = s.id;
      this.data_edit = e;
    },
    deleteRice(e, s) {
      if (e.subDataStock.length > 0) {
        Swal.fire({
          title: "ลบข้อมูลข้าวหม่า",
          text: "ท่านต้องการลบข้อมูลข้าวหม่า ใช่หรือไม่ ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          reverseButtons: true
        }).then(result => {
          if (result.value) {
            this.$store.commit("Loading");
            apiCenterV2.deleteStockandRemain(
              {
                branchName: this.branch.branch_name.substring(
                  4,
                  this.branch.branch_name.length
                ),
                idStock: e.subDataStock[0].id,
                idRice: s.id
              },
              this.header,
              results => {
                if (results.data.isStatus) {
                  this.$notification["success"]({
                    message: "บันทึกสำเร็จ",
                    description: results.data.message
                  });
                  this.getReport();
                } else {
                  this.$notification["warning"]({
                    message: "บันทึกไม่สำเร็จ",
                    description: results.data.message
                  });
                }
                this.$store.commit("Loading");
              },
              errors => {
                this.$store.commit("Loading");
                this.$notification["warning"]({
                  message: "บันทึกไม่สำเร็จ",
                  description: errors.data.message
                });
              }
            );
          }
        });
      }

      // Swal.fire({
      //   title: 'ลบข้อมูลข้าวหม่า',
      //   text: 'ท่านต้องการลบข้อมูลข้าวหม่า ใช่หรือไม่ ?',
      //   icon: 'warning',
      //   showCancelButton: true,
      //   confirmButtonText: 'Yes',
      //   cancelButtonText: 'No',
      //   reverseButtons: true
      // }).then((result) => {
      //   if (result.value) {
      //     this.$store.commit("Loading");
      //     apiCenterV2.deleteStockandRemain(
      //       {
      //         branchName: this.branch.branch_name.substring(
      //             4,
      //             this.branch.branch_name.length
      //           ),
      //         idStock: s.id,
      //         idRemain: d.id
      //       },
      //       this.header,
      //       results => {
      //         if (results.data.isStatus) {
      //           this.$notification["success"]({
      //             message: "บันทึกสำเร็จ",
      //             description: results.data.message
      //           });
      //           this.getReport();
      //         } else {
      //           this.$notification["warning"]({
      //             message: "บันทึกไม่สำเร็จ",
      //             description: results.data.message
      //           });
      //         }
      //         this.$store.commit("Loading");
      //       },
      //       errors => {
      //         this.$store.commit("Loading");
      //         this.$notification["warning"]({
      //           message: "บันทึกไม่สำเร็จ",
      //           description: errors.data.message
      //         });
      //       }
      //     );
      //   }
      // })
    },
    NumbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getReport() {
      console.log(this.branch.branch_name);
      if (this.branch.branch_name != undefined) {
        if (this.branch == 0) {
          this.$store.commit("Loading");
          apiCenterV2.selectRiceSummeryByDateAllBranch(
            {
              startDate: moment(this.startDate).format("yyyyMMDD"),
              endDate: moment(this.endDate).format("yyyyMMDD"),
              branchName: this.$store.state.branch_list
            },
            this.header,
            results => {
              this.$store.commit("Loading");
              if (results.data.isStatus) {
                this.report_data = results.data.data;
                this.form_data = JSON.stringify(this.report_data);
                console.log(this.report_data);
              }
            },
            errors => {
              this.$store.commit("Loading");
              this.$notification["warning"]({
                message: "ไม่สามารถเข้าถึงข้อมูลได้",
                description: errors.data.message
              });
            }
          );
        } else {
          this.$store.commit("Loading");
          apiCenterV2.selectRiceSummeryByDate(
            {
              startDate: moment(this.startDate).format("yyyyMMDD"),
              endDate: moment(this.endDate).format("yyyyMMDD"),
              branchName: this.branch.branch_name.substring(
                4,
                this.branch.branch_name.length
              )
            },
            this.header,
            results => {
              if (results.data.isStatus && results.data.data) {
                let arrayValue = [];
                arrayValue.push({
                  branchName: this.branch.branch_name.substring(
                    4,
                    this.branch.branch_name.length
                  )
                });
                arrayValue[0]["sub"] = results.data.data;
                if (results.data.data.length > 0) this.report_data = arrayValue;
                else this.report_data = [];
              }
              this.form_data = JSON.stringify(this.report_data);
              console.log(this.report_data);
              this.$store.commit("Loading");
            },
            errors => {
              this.$store.commit("Loading");
              this.$notification["warning"]({
                message: "ไม่สามารถเข้าถึงข้อมูลได้",
                description: errors.data.message
              });
            }
          );
        }
      } else {
        // this.$store.commit("Loading");
        this.$store.commit("Loading");
        apiCenterV2.selectRiceSummeryByDateAllBranch(
            {
              startDate: moment(this.startDate).format("yyyyMMDD"),
              endDate: moment(this.endDate).format("yyyyMMDD"),
              branchName: this.$store.state.branch_list
            },
            this.header,
            results => {
              this.$store.commit("Loading");
              if (results.data.isStatus) {
                this.report_data = results.data.data;
                this.form_data = JSON.stringify(this.report_data);
                console.log(this.report_data);
              }
            },
            errors => {
              this.$store.commit("Loading");
              this.$notification["warning"]({
                message: "ไม่สามารถเข้าถึงข้อมูลได้",
                description: errors.data.message
              });
            }
          );
      }
    },
    saveSettingRice() {
      this.$store.commit("Loading");
      apiCenterV2.saveSettingRice(
        {
          riceKilo: this.riceKilos,
          branch: this.$store.state.branch_list
        },
        this.header,
        results => {
          if (results.data.isStatus) {
            this.$notification["success"]({
              message: "บันทึกสำเร็จ",
              description: results.data.message
            });
          }
          this.$store.commit("Loading");
        },
        errors => {
          this.$store.commit("Loading");
          this.$notification["warning"]({
            message: "บันทึกไม่สำเร็จ",
            description: errors.data.message
          });
        }
      );
    },
    selectSettingRice() {
      this.$store.commit("Loading");
      apiCenterV2.selectSettingRice(
        this.header,
        results => {
          if (results.data.isStatus && results.data.data.length > 0) {
            this.riceKilo = results.data.data[0].riceKilo;
          }
          this.$store.commit("Loading");
        },
        errors => {
          console.log(errors);
          this.$store.commit("Loading");
          this.$notification["warning"]({
            message: "ไม่สามารถดึงข้อมูลจากระบบได้",
            description: errors.data.message
          });
        }
      );
    },
    selectDateStart(current) {
      return current && current.valueOf() > this.endDate;
    },
    selectDateEnd(current) {
      return current && current.valueOf() < this.startDate;
    }
  },
  mounted() {
    this.getBranch();
    this.selectSettingRice();
    setTimeout(() => {
      this.addDateWeek();
      this.branch = this.$store.state.branch_list[0];
      this.branchId = this.$store.state.branch_list[0].id;
      this.branchName = this.$store.state.branch_list[0].branch_name;
      this.dyn_address = this.$store.state.branch_list[0].dyn_address;
    }, 500);
  }
};
</script>

<style>
.trTop {
  background-color: #606060 !important;
}

.trMid {
  color: black !important;
  background-color: #d6d6d6 !important;
}

.trBot {
  color: black !important;
  background-color: #fefac0 !important;
}

.tdtextColor {
  color: #ff2f1c !important;
}

.custom-select {
  font-size: 14px;
  height: calc(1.9rem + 2px);
}
.btn {
  font-size: 14px;
}

.justify-r {
  justify-content: right;
}

.formmobile {
  display: none;
}

.formpc {
  display: contents;
}

@media (max-width: 767.98px) {
  .card-body {
    padding: 0;
  }
  .formmobile {
    display: contents;
  }
  .formpc {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/rice_stk.vue